var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Valor de la UF: "+_vm._s(_vm.ufValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }